import useTranslate from '@core/hooks/useTranslate';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Card } from 'antd';
import TableInquiry from '../components/TableInquiry';
import '../../../../styles/pages/warehouse/_inquery/index.scss';
const Breadcrumb = [
  {
    tittle: 'Inquiry',
    url: '/admin/inventory'
  },
  {
    tittle: 'Inquiry List',
    url: ''
  }
];
const InquiryPage = ({ listInquiry, setListInquiry }: any) => {
  const [t] = useTranslate();

  return (
    <>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />

      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <TableInquiry
            listInquiry={listInquiry}
            setListInquiry={setListInquiry}
          />
        </Card>
      </div>
    </>
  );
};

export default InquiryPage;
